import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import type { IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';
import type { CardId, CardEstimate } from '../../../model/types.tsx';
import { type CardSetMeta, setCardSetMeta } from '../meta/card-set-meta.tsx';

export const CARD_ESTIMATE_SET = 'state.actions.estimate.CARD_ESTIMATE_SET' as const;

export type CardEstimateSetAction = {
	type: typeof CARD_ESTIMATE_SET;
	payload: {
		cardId: CardId;
		estimate: Partial<CardEstimate>;
	};
};

export const cardEstimateSet = (
	cardId: CardId,
	estimate: Partial<CardEstimate>,
): CardEstimateSetAction => ({
	type: CARD_ESTIMATE_SET,
	payload: {
		cardId,
		estimate,
	},
});

export const CARD_ESTIMATE_SET_OPTIMISTIC =
	'state.actions.estimate.CARD_ESTIMATE_SET_OPTIMISTIC' as const;

export type CardEstimateSetOptimisticAction = {
	type: typeof CARD_ESTIMATE_SET_OPTIMISTIC;
	payload: CardEstimateSetAction['payload'];
	meta: CardSetMeta;
};

type CardEstimateSetMetaPayload = {
	issueKey: IssueKey;
	estimationFieldId: string;
	isClassicField?: boolean;
};

export const cardEstimateSetOptimistic = (
	payload: CardEstimateSetOptimisticAction['payload'],
	cardSet: CardEstimateSetMetaPayload,
	analyticsEvent: UIAnalyticsEvent,
): CardEstimateSetOptimisticAction => ({
	type: CARD_ESTIMATE_SET_OPTIMISTIC,
	payload,
	meta: setCardSetMeta(
		{
			issueKey: cardSet.issueKey,
			fieldId: cardSet.estimationFieldId,
			newValue: payload.estimate.originalEstimate
				? { originalEstimate: payload.estimate.originalEstimate.valueAsText }
				: payload.estimate.storyPoints,
			retryAction: () => cardEstimateSetOptimistic(payload, cardSet, analyticsEvent),
		},
		analyticsEvent,
	),
});

export type Action = CardEstimateSetOptimisticAction | CardEstimateSetAction;
